import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { ProviderUid } from '@gem/call/CallProviders/callProviders.types';
import { OpponentVideo } from '@gem/call/CallView/Shared/OpponentVideo/OpponentVideo';
import { useOpponentVideoItem } from '@gem/call/CallView/hooks/useOpponentVideoItem/useOpponentVideoItem';
import { AvatarTypes } from '@gem/call/Removable/components/Avatar/Avatar';

import styles from './OpponentVideoItem.styles.m.css';

interface IOpponentVideoItemProps {
  opponentUid: ProviderUid;
}

export const OpponentVideoItem: FC<IOpponentVideoItemProps> = observer(({ opponentUid }) => {
  const { opponent, opponentPosition, onOpponentClick } = useOpponentVideoItem(opponentUid);

  if (!opponent) {
    return null;
  }

  return (
    <OpponentVideo
      isHighlightAudio
      opponent={opponent}
      avatarType={AvatarTypes.Round_10}
      containerClassName={styles.videoContainer}
      isMinimize
      opponentPosition={opponentPosition}
      onClick={onOpponentClick}
    />
  );
});
